import { ACCESS_LEVEL_VIEW } from "../../../../constants";

const isComingSoon = ({ earlyAccess }) =>
  earlyAccess?.customerAccess === ACCESS_LEVEL_VIEW;

export default isComingSoon;
